import React from "react";
import { styled } from "../stitches.config";
import { h4 } from "./commonStyles/Fonts";
import PlayerIconBackground from "./assets/icons/player-icon.svg";


type ExtendedProps = {
    href?: string;
    backgroundSrc?: string;
};
interface VideoReportageAtavistProps {
    blockData: ExtendedProps;
}

export const VideoReportageAtavist: React.FC<VideoReportageAtavistProps> = ({
    blockData,
}) => {

    const {
        backgroundSrc,
        href
    } = blockData;

    return (
        <>
            <VideoReportageWrapper>
                <Image>
                    <img src={backgroundSrc} />
                    <PlayerIcon />
                </Image>

                <div className={h4()}>
                    <p>Dostępny jest widereportaż</p>
                    <a href={href}>Obejrzyj</a>
                </div>
            </VideoReportageWrapper>
        </>
    );
};



const VideoReportageWrapper = styled("div", {
    //margin: 0,
    background: "$grayscale100Fixed",
    width: "calc(100% - 76px)",
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    margin: "0px 38px",
    padding: "24px",
    display: "flex",
    alignItems: "center",

    "@bp4": {
        padding: "48px",
        width: "100%",
        maxWidth: "840px",
        margin: "0px auto",
    },
    "p": {
        color: "$grayscale0 !important",
        margin: "0 0 4px 0",
        fontSize: "14px",
        lineHeight: "20px",
        "@bp4": {
            fontSize: "18px",
            lineHeight: "24px",
        },
    },
    "a": {
        color: "$primary",
        pointer: "cursor",
        textDecoration: "underline",
        fontSize: "14px",
        lineHeight: "20px",
        "@bp4": {
            fontSize: "18px",
            lineHeight: "24px",
        },

        "&:hover": {
            color: "$primary",
        }
    },
    "img": {
        height: "72px",
        width: "108px",
        background: "#fff",
        position: "relative",
    }
});

const Image = styled("div", {
    position: "relative",
    height: "72px",
    width: "108px",
    marginRight: "24px",

    "img": {
        height: "72px",
        width: "108px",
        background: "#fff",
        position: "relative",
    }
});

const PlayerIcon = styled("div", {
    position: "absolute",
    zIndex: 10,
    width: "32px",
    height: "32px",
    content: "",
    backgroundImage: `url("${PlayerIconBackground}")`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "32px",
    top: "20px",
    left: "38px"
});
export default VideoReportageAtavist;
